export const sharedEnvironment = {
  siteConfigurationUrl: 'assets/configuration/site.yml',
  googleAnalyticsToken: 'G-B3DT7XPMRT',

  defaultTheme: {
    primary: '#286F94',
    'primary-text': '#FFFFFF',
    background: '#F2F4F6',
    header: '#616161',
    body: '#424242',
    'link-text': '#1E88E5'
  }
};
